define('lq/asyncSubcriptions',[
    'underscore',
    'lq',
    'when',
    'signalr',
    'signalr.hubs'
], function (_, lq, when, signalR) {
    'use strict';

    // todo svb async in an SPA -> we also have to unsubscribe when closing an action

    var connection = null;
    var subscriptions = {};

    var getRandom = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    };

    var createDatasourceSubscription = function (actionId, receiverIdentifier, filter, callback) {
        var register = function () {
            if ($.connection) {
                return $.connection.asyncHub.server.addDatasourceListener(
                    lq.getTenantName(),
                    lq.getTenantApplicationName(),
                    actionId,
                    receiverIdentifier,
                    filter);
            } else {
                return connection.invoke("AddDatasourceListener",
                    lq.getTenantName(),
                    lq.getTenantApplicationName(),
                    actionId,
                    receiverIdentifier,
                    filter);
            }

        };

        return register()
            .then(function () {
                subscriptions[actionId + '_' + receiverIdentifier] = {
                    callback: callback,
                    register: register
                };
            });
    };

    var createEventSubscription = function (actionId, receiverIdentifier, filter, callback) {
        var register = function () {
            if ($.connection) {
                return $.connection.asyncHub.server.addEventListener(
                    lq.getTenantName(),
                    lq.getTenantApplicationName(),
                    actionId,
                    receiverIdentifier,
                    filter);
            } else {
                return connection.invoke("AddEventListener",
                    lq.getTenantName(),
                    lq.getTenantApplicationName(),
                    actionId,
                    receiverIdentifier,
                    filter);
            }
        };

        return register()
            .then(function () {
                subscriptions[receiverIdentifier] = {
                    callback: callback,
                    register: register
                };
            });
    };

    var callSubscribers = function (receiverIdentifier, calleeArguments) {
        if (subscriptions[receiverIdentifier])
            subscriptions[receiverIdentifier].callback.apply(null, calleeArguments);
    };

    var addSubscription = function (initialiseCallback) {
        var deferred = when.defer();
        if ($.connection) {
            require([
                'signalr.hubs'
            ],
                function () {
                    if ($.connection.hub.state == $.connection.connectionState.connected) {
                        initialiseCallback()
                            .then(function () {
                                deferred.resolve();
                            })
                    } else {
                        $.connection.asyncHub.client.receiveResults = function (rootMorphId, datasourceName, results) {
                            callSubscribers(rootMorphId + '_' + datasourceName, [results]);
                        };
                        $.connection.asyncHub.client.receiveEvent = function (receiverIdentifier, eventName, argument) {
                            callSubscribers(receiverIdentifier, [eventName, argument]);
                        };
                        $.connection.hub.disconnected(function () {
                            var delay = getRandom(200, 2000);

                            setTimeout(function () {
                                $.connection.hub.start()
                                    .then(function () {
                                        _.each(_.keys(subscriptions), function (identifier) {
                                            subscriptions[identifier].register();
                                        subscriptions[identifier].register();
                                            subscriptions[identifier].register();
                                        subscriptions[identifier].register();
                                            subscriptions[identifier].register();
                                        });
                                    });
                            }, delay);
                        });
                        $.connection.hub.logging = true;
                        $.connection.hub.start()
                            .then(function () {
                                return initialiseCallback();
                            })
                            .then(function () {
                                deferred.resolve();
                            });
                    }
                });
        } else {
            connection = new signalR.HubConnectionBuilder()
                .withUrl("/RuntimeHub")
                .build();

            connection.on('ReceiveResults', function (rootMorphId, datasourceName, results) {
                console.log('ReceiveResults');
                var capitalizedResults = { // Have to capitalize the keys of the 'results' object unless it won't work
                    Outputs: results.outputs,
                    Results: results.results,
                    TotalResults: results.totalResults
                };
                callSubscribers(rootMorphId + '_' + datasourceName, [capitalizedResults]);
            });

            connection.on('ReceiveEvent', function (receiverIdentifier, eventName, argument) {
                callSubscribers(receiverIdentifier, [eventName, argument]);
            });

            connection.connection.onclose(function () {
                var delay = getRandom(200, 2000);

                setTimeout(function () {
                    connection.start().then(function () {
                        _.each(_.keys(subscriptions), function (identifier) {
                            subscriptions[identifier].register();
                        subscriptions[identifier].register();
                            subscriptions[identifier].register();
                        subscriptions[identifier].register();
                            subscriptions[identifier].register();
                        });
                    });
                }, delay);
            });

            var start = function () {
                 connection.start().then(function () {
                    try {
                        connection.invoke("OnConnected", lq.getTenantName() + '/' + lq.getTenantApplicationName())
                            .then(function () {
                               initialiseCallback().then(function () {
                                    deferred.resolve();
                                });
                            });
                    } catch (err) {
                        console.error(err);
                    }
                 });
            }
            start();
        }

        return deferred.promise;
    }

    var addDatasourceSubscription = function (piping, receiverIdentifier, filter, callback) {
        var key = piping.actionId + '_' + receiverIdentifier;
        if (!!subscriptions[key])
            return when.resolve();

        filter = piping.parameters.replace(filter);

        return addSubscription(function () {
            return createDatasourceSubscription(piping.actionId, receiverIdentifier, filter, callback);
        });
    };

    var addEventSubscription = function (piping, receiverIdentifier, filter, callback) {
        if (!!subscriptions[receiverIdentifier])
            return when.resolve();

        filter = piping.parameters.replace(filter);

        return addSubscription(function () {
            return createEventSubscription(piping.actionId, receiverIdentifier, filter, callback);
        });
    };

    return {

        addDatasourceSubscription: addDatasourceSubscription,
        addEventSubscription: addEventSubscription

    };
});
